/*
 * @Author: 何治国 1633779634@qq.com
 * @Date: 2024-11-06 15:12:04
 * @LastEditors: 何治国 1633779634@qq.com
 * @LastEditTime: 2024-11-06 19:04:41
 * @FilePath: /console-source/src/api/subaccount.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request"
import requestPhone from "@/utils/requestPhone"


//子账号列表
export function listsub(data) {
    return request({
        url: '/user/list_sub',
        method: 'post',
        data
    })
}

//创建子账号
export function createsub(data) {
    return request({
        url: '/user/create_sub',
        method: 'post',
        data
    })
}

//修改子账号昵称
export function modifysub(data) {
    return request({
        url: '/user/modify_sub',
        method: 'post',
        data
    })
}

//删除子账号
export function deletesub(data) {
    return request({
        url: '/user/delete_sub',
        method: 'post',
        data
    })
}

//重置子账号密码
export function resetpassword(data) {
    return request({
        url: '/user/sub_reset_password',
        method: 'post',
        data
    })
}


//子账号登录
export function sublogin(data) {
    return request({
        url: '/user/sub_login',
        method: 'post',
        data
    })
}
